import React, { memo } from "react";

import { Box } from "@chakra-ui/react";
import {
  renderCheckboxFilters,
  renderDateRangeFilter,
  renderRadioFilters,
  renderSelectFilter,
} from "utils/filter";

import { filterBodyWrapperCss } from "../filter-body/styles";
import { FilterFooter } from "../filter-footer";
import { FilterHeader } from "../filter-header";
import { TFilterOption, TFilterValue, TFilterValues } from "../types";
import { IFilterPopUpContentProps } from "./types";

const renderers: Record<
  TFilterOption["type"],
  (
    filter: TFilterOption,
    values: TFilterValues,
    onChange: (key: string, value: TFilterValue) => void
  ) => React.ReactNode
> = {
  checkbox: renderCheckboxFilters,
  "date-range": renderDateRangeFilter,
  select: renderSelectFilter,
  radio: renderRadioFilters,
};

export const FilterPopUpContent = memo((props: IFilterPopUpContentProps) => {
  const {
    handleApplyFilter,
    handleToggleFilter,
    options,
    values,
    onChange,
    isLoading,
    header,
    headerTitle,
    footer,
    customFilterBodyCss,
    isApplyBtnDisabled,
    handleResetFilter,
  } = props;

  return (
    <>
      <>
        {header ? (
          header
        ) : (
          <FilterHeader
            handleToggleFilter={handleToggleFilter}
            isLoading={isLoading}
            title={headerTitle}
          />
        )}
      </>
      <Box css={{ ...filterBodyWrapperCss, ...customFilterBodyCss }}>
        {options.map((option) => {
          const { type, key } = option;
          return (
            <Box key={key}>{renderers[type](option, values, onChange)}</Box>
          );
        })}
      </Box>
      <>
        {footer ? (
          footer
        ) : (
          <FilterFooter
            handleToggleFilter={handleToggleFilter}
            handleApplyFilter={handleApplyFilter}
            isLoading={isLoading}
            isApplyBtnDisabled={isApplyBtnDisabled}
            handleResetFilter={handleResetFilter}
          />
        )}
      </>
    </>
  );
});
